import React, { useEffect, useState } from "react";
import { withFormik, InjectedFormikProps } from "formik";
import { Link } from "react-router-dom";
import { routes } from "../../../routes";
import RegisterFormFields, { IRegisterFormElementsValues } from "./registerFormElements";
import { Form } from "reactstrap";
import { connect } from "react-redux";
import Button from "../../../../components/common/button";
import userService from "../../../../services/userService";
import { RegisterValidation } from "../../../../validations/registerValidation";
import { IRegisterRequest, IRegisterUserResponse } from "../../../../interfaces/user";
import companyService from "../../../../services/companyService";
import commonService from "../../../../services/commonService";

interface IRegisterForProps {
	register: (
		request: IRegisterRequest,
		resolve?: Function,
		reject?: Function
	) => Promise<IRegisterUserResponse>;
	setModal: (isOpen: boolean) => void;
	getCompanyTypes: () => Promise<any>;
	getCountries: () => Promise<any>;
}

const RegisterForm: React.FC<
	InjectedFormikProps<IRegisterForProps, IRegisterFormElementsValues>
> = (props) => {
	const [companyTypeOptions, setCompanyTypeOptions] = useState<any>([]);
	const [countryOptions, setCountryOptions] = useState<any>([]);

	useEffect(() => {
		props.getCompanyTypes().then((res: any) => {
			setCompanyTypeOptions(res);
		});
		props.getCountries().then((res: any) => {
			setCountryOptions(res);
		});
	}, []);

	return (
		<Form className="mt-1" onSubmit={props.handleSubmit}>
			<div className="header">
				<h1>Create Account </h1>
			</div>
			<RegisterFormFields companyTypeOptions={companyTypeOptions} countryOptions={countryOptions} {...props} />
			<div className="btn-container">
				<Button
					type="submit"
					className="btn-success"
					style={{ color: "white" }}
					loading={props.isSubmitting}
					size="lg"
					disabled={!props.isValid || props.isSubmitting}
				>
					Register
				</Button>
			</div>
			<div className="mt-4 pt-3 text-center" style={{ borderTop: '1px solid #f0f0f0' }}>
				<p style={{ fontSize: '13px', color: '#666', marginBottom: '8px' }}>Are you a developer?</p>
				<Link to={routes.DEVELOPER_PORTAL_SIGNUP} style={{ fontSize: '14px', fontWeight: 600, color: '#17C9DC', textDecoration: 'none' }}>
					Create a Developer Account
				</Link>
			</div>
		</Form>
	);
};

// eslint-disable-next-line @typescript-eslint/ban-types
const WrappedForm = withFormik<IRegisterForProps, IRegisterFormElementsValues>({
	enableReinitialize: true,
	validationSchema: RegisterValidation,

	mapPropsToValues: () => ({
		firstName: "",
		lastName: "",
		company: "",
		jobtitle: "",
		city: "",
		companyType: "",
		phoneNumber: "",
		state: "",
		country: "",
		email: "",
		password: "",
		confirmPassword: ""
	}),

	handleSubmit: async (values, { props, setSubmitting, setFieldError }) => {
		try {
			setSubmitting(true);
			await props.register(values);
			props.setModal(true);
		} catch (e) {
			const err = e as any;
			if (err.response?.status == 404) {
				setFieldError("email", "Email is already in use");
			}
		} finally {
			setSubmitting(false);
		}
	}
});

const mapDispatchToProps = (dispatch: any) => ({
	register: async (registerData: IRegisterRequest, resolve?: Function, reject?: Function) =>
		dispatch(userService.register(registerData, resolve, reject)),
	getCompanyTypes: () => dispatch(companyService.getCompanyTypes()),
	getCountries: () => commonService.getCountries()
});

export default connect(null, mapDispatchToProps)(WrappedForm(RegisterForm));
